<template>
  <div id="mask" class="mask-show login-mask-sheet" v-if="visible" @click.self="closeDialog">
    <div class="loginForm login-sheet" style="display: block;">
      <div class="close" @click="closeDialog"></div>
      <img class="logo" alt="logo" src="@/assets/images/logo.png" style="visibility: visible;">
      <div class="login-item login-user">
        <input id="loginUser" v-model.trim="username" data-field="username" type="text" maxlength="14"
          placeholder="6-14 digit atau kombinasi huruf" autocomplete="username">
      </div>
      <div class="login-item login-psw">
        <input id="loginPsw" v-model="password" data-field="password" :type="showPassword ? 'text' : 'password'"
          maxlength="16" placeholder="6-16 angka atau kombinasi huruf" autocomplete="current-password"
          @keyup.enter="handleLogin">
        <b :class="{ showPsw: showPassword }" @click="showPassword = !showPassword"></b>
      </div>
      <div class="memberPsw">
        <input id="login-member" v-model="rememberPassword" type="checkbox" value="1">
        <label for="login-member">Ingat password Anda?</label>
      </div>
      <div class="login-btn" @click="handleLogin">Masuk</div>
      <div class="other-item">
        <b style="cursor: pointer;" @click="go('/forget')">Lupa password</b>
        <b style="cursor: pointer;" @click="go('/register')">Daftar</b>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { login } from '@/api'
import { toastSuccess, toastWarn } from '@/utils/toast'

export default {
  name: 'LoginDialog',
  data() {
    return {
      username: '',
      password: '',
      rememberPassword: false,
      showPassword: false
    }
  },
  computed: {
    ...mapState('user', {
      visible: state => state.loginTan
    })
  },
  methods: {
    closeDialog() {
      this.$store.dispatch('user/setLoginDialog', false)
    },
    go(path) {
      this.closeDialog()
      this.$router.push(path)
    },
    async handleLogin() {
      const username = (this.username || '').trim()
      const password = this.password || ''
      if (!username || !password) {
        toastWarn('Mohon isi Username dan Password')
        return
      }
      try {
        const res = await login({ username, password })
        if (res && res.code === 1 && res.data) {
          localStorage.setItem('salt', res.data.salt || '')
          localStorage.setItem('uuid', res.data.uuid || '')
          await this.$store.dispatch('user/fetchUserInfo')
          this.$store.dispatch('user/setLoginDialog', false)
          this.$store.dispatch('user/setLoginRulesNotify', true)
          toastSuccess(res.message || 'Berhasil masuk')
        }
      } catch (e) {
        // error toast handled by interceptor
      }
    }
  }
}
</script>

<style scoped>
.login-mask-sheet {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  z-index: 100000;
}

.login-sheet {
  width: 100%;
  max-width: 52rem;
  margin: 0 auto;
  border-radius: 1.2rem 1.2rem 0 0;
  animation: loginSheetRise 0.28s ease-out;
}

.login-sheet .login-psw b.showPsw {
  background: url("~@/assets/images/icon-eyes-open.png") no-repeat center right/contain !important;
}

@keyframes loginSheetRise {
  from {
    transform: translateY(100%);
    opacity: 0.6;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.black-gold-theme .user .loginBtn,
.black-gold-theme .loginForm .login-btn {
  background: linear-gradient(270deg, #fde4a7 0%, #c59a5a 20%, #7c511d 45%, #eedec7 60%, #efb05a 80%, #c59a5a 100%);
  animation: gradient 4s ease infinite !important;
  background-size: 400% 400%;
  box-shadow: inset 0 0 5px 2px #c8a177, inset 0 2px 0 0 #fff8e7, inset 0 0 0 2px #7c511d, 3px 3px 3px 1px rgba(0, 0, 0, .25);
  border: 1px solid #9b7034 !important;
  color: #2b1a08;
  padding: 0rem 2.5rem;
  font-weight: bold;
  text-transform: uppercase;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: auto;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>
